import type { useI18n } from '@change-corgi/core-react/i18n';

import { buildIssuePersonalStorySchema } from '#src/app/shared/utils/sap';

type BuildSchemaParams = { translate: ReturnType<typeof useI18n>['translate'] };

export function buildSchema({ translate }: BuildSchemaParams) {
	return buildIssuePersonalStorySchema(translate('corgi.start_a_petition.issue_prompt.error'));
}
